import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';
import { Button } from './ui/button';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    document.getElementById(sectionId)?.scrollIntoView({ behavior: 'smooth' });
    setIsMobileMenuOpen(false);
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    setIsMobileMenuOpen(false);
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-white/95 backdrop-blur-md shadow-lg'
          : 'bg-transparent'
      }`}
    >
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between py-4 min-h-[140px]">
          {/* Logo */}
          <button
            onClick={scrollToTop}
            className="flex items-center gap-3 group"
          >
            <img 
              src="https://customer-assets-v7afamib.emergentagent.net/job_oahu-photo-book/artifacts/vq1lq6kc_front-1.jpg"
              alt="Kawika Moments Logo"
              className="h-32 w-32 rounded-full object-cover shadow-lg transition-transform duration-300 group-hover:scale-105"
            />
            <span
              className={`text-xl font-bold transition-colors duration-300 ${
                isScrolled ? 'text-slate-900' : 'text-white'
              }`}
            >
              Kawika Moments
            </span>
          </button>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center gap-8">
            <button
              onClick={() => scrollToSection('portfolio')}
              className={`font-medium transition-colors duration-300 hover:text-cyan-600 ${
                isScrolled ? 'text-slate-700' : 'text-white'
              }`}
            >
              Portfolio
            </button>
            <button
              onClick={() => scrollToSection('about')}
              className={`font-medium transition-colors duration-300 hover:text-cyan-600 ${
                isScrolled ? 'text-slate-700' : 'text-white'
              }`}
            >
              About
            </button>
            <button
              onClick={() => scrollToSection('services')}
              className={`font-medium transition-colors duration-300 hover:text-cyan-600 ${
                isScrolled ? 'text-slate-700' : 'text-white'
              }`}
            >
              Services
            </button>
            <button
              onClick={() => scrollToSection('pricing')}
              className={`font-medium transition-colors duration-300 hover:text-cyan-600 ${
                isScrolled ? 'text-slate-700' : 'text-white'
              }`}
            >
              Pricing
            </button>
            <Button
              onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
              className="bg-gradient-to-r from-cyan-500 to-teal-500 hover:from-cyan-600 hover:to-teal-600 text-white px-6 shadow-lg hover:shadow-xl transition-all duration-300"
            >
              Book Now
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className={`md:hidden p-2 rounded-lg transition-colors duration-300 ${
              isScrolled ? 'text-slate-900' : 'text-white'
            }`}
          >
            {isMobileMenuOpen ? (
              <X className="w-6 h-6" />
            ) : (
              <Menu className="w-6 h-6" />
            )}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="md:hidden bg-white border-t border-slate-200 shadow-xl">
          <div className="container mx-auto px-4 py-6 space-y-4">
            <button
              onClick={() => scrollToSection('portfolio')}
              className="block w-full text-left py-2 text-slate-700 hover:text-cyan-600 font-medium transition-colors duration-300"
            >
              Portfolio
            </button>
            <button
              onClick={() => scrollToSection('about')}
              className="block w-full text-left py-2 text-slate-700 hover:text-cyan-600 font-medium transition-colors duration-300"
            >
              About
            </button>
            <button
              onClick={() => scrollToSection('services')}
              className="block w-full text-left py-2 text-slate-700 hover:text-cyan-600 font-medium transition-colors duration-300"
            >
              Services
            </button>
            <button
              onClick={() => scrollToSection('pricing')}
              className="block w-full text-left py-2 text-slate-700 hover:text-cyan-600 font-medium transition-colors duration-300"
            >
              Pricing
            </button>
            <Button
              onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
              className="w-full bg-gradient-to-r from-cyan-500 to-teal-500 hover:from-cyan-600 hover:to-teal-600 text-white shadow-lg"
            >
              Book Now
            </Button>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
